import { View, Heading, Image, Text, useTheme } from '@aws-amplify/ui-react';
import logo from '@/assets/IE_logo.svg';
import { useTypeSafeTranslation } from '@/i18n';

const AuthenticatorComponents = {
  Header(): JSX.Element {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image alt="IE logo" src={logo} width="70%" />
      </View>
    );
  },

  Footer(): JSX.Element {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={`${tokens.colors.neutral['80']}`}>Copyright &copy; 2022 Insight Edge, Inc.</Text>
      </View>
    );
  },

  SignIn: {
    Header(): JSX.Element {
      const { tokens } = useTheme();
      const { t } = useTypeSafeTranslation();

      return (
        <Heading textAlign="center" padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          {t('common.appName')}
        </Heading>
      );
    },
  },
};

export default AuthenticatorComponents;
